"use client";

import React from "react";
import GSTRegistrationSimulation from "../../components/GSTRegistrationSimulation";

export default function GSTRegistrationPage() {
  return (
    <div>
      <GSTRegistrationSimulation />
    </div>
  );
}
